<template lang="pug">
div
  .heading.mb-M
    h2 Filter - Occasions
    BriqButton(variant="main" small ref="addFilterTheme" @click="addFilterTheme()"  v-show="!showTranslations" data-test-id="add-occasion") Add occasion
  .theme-selector-theme(v-for="(theme, themeKey) in themes")
    BriqCheckbox.theme-selector-checkbox(label="Show" v-model="theme.active" @input="updateShowForTranslationInfoObject(themeKey, theme.active)" v-show="!showTranslations")
    BriqInput.theme-selector-name(
      label="Occasion label"
      required
      v-model="theme.name"
      :disabled="!themeKey.includes(`new`) && !showTranslations"
      :error="!showTranslations ? themeError(themeKey) : null"
      @blur="$v.themes.$each[themeKey].name.$touch()"
    )
    .theme-selector-delete(@click="removeFilterTheme(themeKey)"  v-show="!showTranslations")
      BriqIcon(name="icon-input-trash-icon")
</template>

<script>
import Vue from 'vue'
import { required } from 'vuelidate/lib/validators'
import { extractNumberFromString } from '@v/util/extractNumberFromString.js'
import { isEmpty } from 'ramda'
import translationInfoHelperFunctionsMixin from '@v/util/translationInfoHelperFunctionsMixin.js'

export default {
  name: 'ThemeSelector',
  mixins: [translationInfoHelperFunctionsMixin],
  props: {
    themes: {
      type: Object,
      required: true,
    },
    translationInfo: {
      type: Object,
      required: false,
    },
    validations: {
      type: Object,
      required: true,
    },
    showTranslations: Boolean,
  },
  data() {
    return {
      errorMessage: 'This field is required',
    }
  },
  methods: {
    addFilterTheme() {
      const themeKeys = Object.keys(this.themes)
      const lastThemeKey = themeKeys.length > 0 ? extractNumberFromString(themeKeys.pop()) : 0

      const element = {
        active: true,
        name: '',
        slug: '',
      }
      Vue.set(this.themes, 'new-' + (lastThemeKey + 1), element)
      this.addNewElementTranslationInfoObject({
        translationInfo: this.translationInfo,
        key: lastThemeKey,
        elementToBeAdded: element,
        translationsProperty: 'Theme',
      })
    },
    removeFilterTheme(themeKey) {
      this.$delete(this.themes, themeKey)
      this.removeElementTranslationInfoObject({
        self: this,
        translationInfo: this.translationInfo,
        key: themeKey,
        translationsProperty: 'Theme',
      })
    },
    themeError(themeKey) {
      return (this.$v.themes.$each[themeKey].name && this.$v.themes.$each[themeKey].$error) ||
        (this.validations.$each?.[themeKey].name && this.validations.$each?.[themeKey].$error)
        ? this.errorMessage
        : null
    },
    updateShowForTranslationInfoObject(themeKey, active) {
      if (isEmpty(this.translationInfo.AvailableCultures)) return false
      const translationInfo = this.translationInfo
      this.translationInfo.AvailableCultures.forEach(function(availableCulture) {
        translationInfo.Translations[availableCulture.Name].Theme[themeKey].active = active
      })
    },
  },
  validations() {
    return {
      themes: {
        $each: {
          name: { required },
        },
      },
    }
  },
}
</script>

<style scoped lang="stylus">
.heading
  display flex
  justify-content space-between
  align-items center

.theme-selector-theme
  display flex
  align-items center

.theme-selector-checkbox
  width 100px
  padding-top 20px

.theme-selector-name
  width 85%

.theme-selector-delete
  margin 0 auto
  cursor pointer
  padding-left 20px
</style>
